import { Icon, IconProps } from './Icon';

interface GlobalIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const GlobalIcon = ({ color = '#5E6A81', gradient, ...props }: GlobalIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5003 19.8331L18.667 17.4998L15.2277 15.1886L12.9608 15.0439L11.667 16.3331L14.0003 19.8331H17.5003Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.949 3.54131C8.38764 2.97081 2.97081 8.38764 3.54131 14.949C3.97531 19.9411 8.05864 24.0245 13.0508 24.4585C19.6121 25.029 25.029 19.6133 24.4585 13.0508C24.0245 8.05981 19.9411 3.97648 14.949 3.54131Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.60938 9.28769L9.33321 12.8332L10.5057 10.5057L15.1665 9.33319L16.5455 3.81836"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
